import { createSlice } from '@reduxjs/toolkit';
import type { Service, Account, ServiceMetadata } from '../types.ts';
import servicesApi from '../api/serviceApi.ts';
import accountsServices from '../api/accountApi.ts';
import { getCurrentAccountId } from '../../utils/tokenUtils.ts';

export interface InitialState {
  frameworkMode: 'USER' | 'ACCOUNT';
  servicesList: Service[];
  accountsList: Account[];
  publicServicesList: Service[];
  isServicesLoading?: boolean;
  init: boolean;
  serviceMetadata: null | ServiceMetadata;
  currentService: null | Service;
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    servicesList: [],
    isServicesLoading: false,
    frameworkMode: getCurrentAccountId() === null ? 'USER' : 'ACCOUNT',
    accountsList: [],
    publicServicesList: [],
    init: true,
    serviceMetadata: null,
    currentService: null,
  } as InitialState,
  reducers: {
    setFrameworkMode: (state, action) => {
      state.frameworkMode = action.payload;
    },
    setInit: (state, action) => {
      state.init = action.payload;
    },
    setServiceMetadata: (state, action) => {
      state.serviceMetadata = action.payload;
    },
    setCurrentService: (state, action) => {
      state.currentService = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(servicesApi.endpoints.getServices.matchPending, state => {
      state.isServicesLoading = true;
    });
    builder.addMatcher(servicesApi.endpoints.getServices.matchFulfilled, (state, action) => {
      state.servicesList = action.payload;
      state.isServicesLoading = false;
    });
    builder.addMatcher(servicesApi.endpoints.getServices.matchRejected, state => {
      state.isServicesLoading = false;
    });
    builder.addMatcher(accountsServices.endpoints.getAccountsList.matchFulfilled, (state, action) => {
      state.accountsList = action.payload;
    });
    builder.addMatcher(servicesApi.endpoints.getPublicServices.matchFulfilled, (state, action) => {
      state.publicServicesList = action.payload;
      state.isServicesLoading = false;
    });
    builder.addMatcher(servicesApi.endpoints.getPublicServices.matchPending, state => {
      state.isServicesLoading = true;
    });
    builder.addMatcher(servicesApi.endpoints.getPublicServices.matchRejected, state => {
      state.isServicesLoading = false;
    });
  },
});

export const { setFrameworkMode, setInit, setServiceMetadata, setCurrentService } = layoutSlice.actions;
export default layoutSlice.reducer;
